export default [
    {
        path: "/compliance/suspensions/new",
        name: "new-suspension",
        meta: {
            title: "New Suspension",
            authRequired: true,
        },
        component: () => import("../views/suspensions/new-suspension.vue"),
    },
    {
        path: "/compliance/suspensions",
        name: "suspended-suppliers",
        meta: {
            title: "Suspended Suppliers",
            authRequired: true,
        },
        component: () => import("../views/suspensions/suspended-suppliers.vue"),
    },
    {
        path: "/compliance/suspensions/view",
        name: "view-suspension",
        meta: {
            title: "View Suspension",
            authRequired: true,
        },
        component: () => import("../views/suspensions/view-suspension.vue"),
    },
    {
        path: "/compliance/suspensions/approve",
        name: "supplier-suspension-approval",
        meta: {
            title: "Approve Suspension",
            authRequired: true,
        },
        component: () => import("../views/suspensions/approve-suspension.vue"),
    },
    {
        path: "/compliance/barrings/new",
        name: "new-barring",
        meta: {
            title: "New Fine/Suspension",
            authRequired: true,
        },
        component: () => import("../views/fines-and-suspensions/new-fine-suspension.vue"),
    },
    {
        path: "/compliance/barrings",
        name: "barred-suppliers",
        meta: {
            title: "Fines and Suspensions",
            authRequired: true,
        },
        component: () => import("../views/fines-and-suspensions/fines-and-suspensions.vue"),
    },
    {
        path: "/compliance/barrings/view",
        name: "view-barring",
        meta: {
            title: "View Fine/Suspension",
            authRequired: true,
        },
        component: () => import("../views/fines-and-suspensions/view-fine-suspension.vue"),
    },
    {
        path: "/compliance/barrings/approve",
        name: "supplier-barring-approval",
        meta: {
            title: "Approve Fine/Suspension",
            authRequired: true,
        },
        component: () => import("../views/fines-and-suspensions/approve-fine-suspension.vue"),
    },
    {
        path: "/compliance/suspensions/lifting/new",
        name: "new-suspension-lifting",
        meta: {
            title: "Lift Suspension",
            authRequired: true,
        },
        component: () => import("../views/suspensions/new-suspension-lifting.vue"),
    },
    {
        path: "/compliance/suspensions/lifting/approve",
        name: "supplier-reverse-suspension-approval",
        meta: {
            title: "Approve Suspension Lifting",
            authRequired: true,
        },
        component: () => import("../views/suspensions/approve-suspension-lifting.vue"),
    },
    {
        path: "/compliance/barrings/lifting/new",
        name: "new-barring-lifting",
        meta: {
            title: "Lift Fine/Suspension",
            authRequired: true,
        },
        component: () => import("../views/fines-and-suspensions/new-fine-suspension-lifting.vue"),
    },
    {
        path: "/compliance/barrings/lifting/approve",
        name: "supplier-reverse-barring-approval",
        meta: {
            title: "Approve Fine/Suspension Lifting",
            authRequired: true,
        },
        component: () => import("../views/fines-and-suspensions/approve-fine-suspension-lifting.vue"),
    },
]
